export class RiskDetails_DH{

    public IqamaNo: string;
    public Name: string;
    public DOB: Date;
    public Helper_Age_AsOnDate: number;
    public Gender: number;
    public Nationality: number;
    public PoBoxNo: number;
    public PassportNo: string;
    public VisaNo: string;
    public BorderNo: string;
    public AmericanID: string;
}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Models/RiskDetails_DH.ts